import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'pdf-zoom-out',
  templateUrl: './pdf-zoom-out.component.html',
  styleUrls: ['./pdf-zoom-out.component.css']
})
export class PdfZoomOutComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
